import * as _ from 'lodash';
import { createContext } from 'react';

import type { DependencyInfoOption } from '../../shared/types';

type Context = {
  dependencyInfoOptions: DependencyInfoOption[];
  setDependencyInfoOptions: (options: DependencyInfoOption[]) => void;
};

export const ReportContainerContext = createContext<Context>({
  dependencyInfoOptions: [],
  setDependencyInfoOptions: _.noop,
});

export const Provider = ReportContainerContext.Provider;
